const API_URL = 'https://polar-river-02223.herokuapp.com/'

export default API_URL; 